import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Virtueal_LOGO_BASE_E_B.png'
import _imports_1 from '@/assets/images/QRcode.png'


const _withScopeId = n => (_pushScopeId("data-v-b0a8fc44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "callMelogo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "introduce" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "callMeLine" }, null, -1))
const _hoisted_4 = { class: "contact" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qrCode",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "086-010-51078067", -1))
const _hoisted_8 = { class: "label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "contact@virtueal.cn", -1))
const _hoisted_10 = { class: "label" }

import { computed } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['box', { mobileSize: _unref(isMobile) }])
  }, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("faq.company_details")), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("faq.phone")) + ":", 1),
            _hoisted_7
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("faq.email")) + ":", 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("faq.address")) + ":", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("header.company_address")), 1)
          ])
        ])
      ])
    ])
  ], 2))
}
}

})